import { EcpStoreType } from '../../rest/ecp-locator';
import { EcpServices } from '../../components/business/app/ecp-locator';

export const getServices = (service: EcpServices | null): EcpStoreType | '' => {
  switch (service) {
    case EcpServices.fit:
    case EcpServices.cv:
    case EcpServices.aec:
      return EcpStoreType.fitter;
    case EcpServices.buy:
      return EcpStoreType.retailer;
    default:
      return '';
  }
};

